<template>
  <div v-if="props.article" class="article-detail">
    <!-- Title -->
    <h1 class="h1" v-html="props.article?.title" />

    <!-- Main gallery / image -->
    <DefaultArticlesArtObjectsGalleryPreview
      v-if="getMainGalleryImages().length > 0"
      :images="getMainGalleryImages()"
      :detail-url="getGalleryPath()"
    />

<!--    <DefaultArticlesArtObjectsGallery-->
<!--      v-if="getMainGalleryImages().length > 0"-->
<!--      :images="getMainGalleryImages()"-->
<!--    />-->
    <div
      v-else-if="getMainGalleryImages().length === 1"
      class="ao__aside"
    >
      <DefaultArticlesArtObjectsImage
        :image="getMainGalleryImages().at(0)"
      />
    </div>

    <DefaultArticlesArticleImage
      v-else-if="mainImage"
      :src="mainImage"
      :alt="props.article?.title || ''"
      :source="mainImageSource"
      :caption="mainImageCaption"
    />

    <!-- Author and date -->
    <div class="flex justify-between items-start">
      <DefaultArticlesAuthorAndDateInfo
        :is-detail="true"
        :author="props.article?.simpleAuthor"
        :published="props.article?.publishedDate"
        link="/"
      />
      <!--                <DefaultArticlesDiscussionButton/>-->
    </div>

    <!-- PEREX -->
    <div
      v-if="props.article?.perex"
      class="ao__perex text-lg leading-7 text-left"
      v-html="props.article?.perex"
    />

    <!-- CNC Ads - below perex -->
    <DefaultAdsCncWrapper
      :position="UniFeAdsPosition.BELOW_PEREX"
      :page="props.cncAdsPage"
    />

    <!-- RATING -->
    <DefaultArticlesArtObjectsRating
      v-if="article?.ratingDecoded && article?.ratingDecoded.rating"
      :payload="article?.ratingDecoded"
    />

    <!-- Art Objects -->
    <DefaultArticlesArtObject
      v-for="artObject in props.article?.jsonBodyDecoded"
      :type="artObject?.type"
      :payload="artObject"
      :parent-ident="`article-${props.article?.id}`"
    />

    <!-- Social and discussion -->
    <div class="flex justify-between">
      <DefaultShareSocialList/>
      <!--                  <DefaultArticlesDiscussionButton-->
      <!--                    :is-detail="true"-->
      <!--                  />-->
    </div>

    <!-- Keywords -->
    <div class="flex flex-wrap gap-3 mt-6 sm:mt-10 lg:mt-12">
      <NuxtLink
        v-for="keyword in props.article?.keywords"
        class="articleid__filter-item"
        :to="getSearchResultPath(keyword)"
      >
        {{ keyword }}
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import {UniFeAdsPosition} from "~/libs/constants/UniFeAdsPosition"
import type {PropType} from "vue"
import type ArticleLocal from "~/libs/interfaces/ArticleLocal"
import {CncAdsPage} from "~/libs/constants/CncAdsPage"
import type AssetLocal from "~/libs/interfaces/AssetLocal"
import {useArticleTools} from "~/composables/useArticleTools"

const props = defineProps({
  article: {type: Object as PropType<ArticleLocal>, required: false},
  cncAdsPage: {type: String as PropType<CncAdsPage>, required: true},
})

const logger = useFrontendLogger()

const mainImage = computed(() => {
  return props.article?.previewAsset?.urlWithProtocol || props.article?.articleLinkAssetList?.edges?.at(0)?.node?.asset?.urlWithProtocol || null
})

const mainImageSource = computed(() => {
  return props.article?.previewAsset?.source || props.article?.articleLinkAssetList?.edges?.at(0)?.node?.asset?.source || null
})

const mainImageTitle = computed(() => {
  return props.article?.previewAsset?.title || props.article?.articleLinkAssetList?.edges?.at(0)?.node?.asset?.title || null
})

const mainImageCaption = computed(() => {
  return props.article?.previewAsset?.caption || props.article?.articleLinkAssetList?.edges?.at(0)?.node?.asset?.caption || null
})


const getGalleryPath = () => {
  return useArticleTools(props.article).getGalleryPath()
}

const getMainGalleryImages = (): AssetLocal[] => {
  const pathRegex = /^(http|https)/;
  const images: AssetLocal[] = []
  if (props.article?.articleLinkAssetList?.edges) {
    props.article?.articleLinkAssetList?.edges.forEach((image) => {
      if (image?.node?.asset?.urlWithProtocol && pathRegex.test(image?.node?.asset?.urlWithProtocol)) {
        images.push({
          urlWithProtocol: image.node?.asset?.urlWithProtocol,
          caption: image.node?.asset?.caption,
          title:  image.node?.asset?.title,
          source:  image.node?.asset?.source,
        })
      } else {
        logger.info('Article asset path is invalid', {
          ArticleId: `${props.article?.id}`,
          ArticlePath: `${props.article?.path}`,
          AssetId: image?.node?.id,
          AssetPath: image?.node?.asset?.urlWithProtocol,
        })
      }
    })
    // remove the first image when the first image is the same as the header photo
    if (mainImage.value && images.length > 0 && mainImage.value === images.at(0)?.urlWithProtocol) {
      images.shift()
    }
  }
  return images
}

const getSearchResultPath = (query: string) => {
  return useArticleTools().getSearchResultPath(query)
}
</script>
